<template>
  <v-container>
    <h3>近兩周預約場次</h3>
    <v-data-table
      :headers="headers"
      :items="sections.next"
      no-data-text="無場次"
      :items-per-page="-1"
      hide-default-footer
    >
      <!-- <template v-slot:item.整合式篩檢="{ item }">
        <v-icon large v-if="item.整合式篩檢">mdi-hospital-marker</v-icon>
      </template> -->
    </v-data-table>
    <h3>今年已完成場次</h3>
    <v-data-table
      :headers="headers"
      :items="sections.past"
      no-data-text="無場次"
    ></v-data-table>
    <template v-if="panel">
      <h3>年度累積成果</h3>
      <h5>最後更新時間: {{ lastUpdate }}</h5>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">年齡區段</th>
              <th class="text-left">性別</th>
              <th class="text-left">人數</th>
              <th class="text-left">預約率</th>
              <th class="text-left">報到率</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="2">39 歲以下</td>
              <td>男性</td>
              <td>{{ panel.t1.list_male }}人</td>
              <td>
                {{
                  ((panel.t1.reserve_male / panel.t1.list_male) * 100).toFixed(
                    2
                  )
                }}% ({{ panel.t1.reserve_male }}人)
              </td>
              <td>
                {{
                  (
                    (panel.t1.checkin_male / panel.t1.reserve_male) *
                    100
                  ).toFixed(2)
                }}% ({{ panel.t1.checkin_male }}人)
              </td>
            </tr>
            <tr>
              <td>女性</td>
              <td>{{ panel.t1.list_female }}人</td>
              <td>
                {{
                  (
                    (panel.t1.reserve_female / panel.t1.list_female) *
                    100
                  ).toFixed(2)
                }}% ({{ panel.t1.reserve_female }}人)
              </td>
              <td>
                {{
                  (
                    (panel.t1.checkin_female / panel.t1.reserve_female) *
                    100
                  ).toFixed(2)
                }}% ({{ panel.t1.checkin_female }}人)
              </td>
            </tr>
            <tr>
              <td rowspan="2">40~64 歲</td>
              <td>男性</td>
              <td>{{ panel.t2.list_male }}人</td>
              <td>
                {{
                  ((panel.t2.reserve_male / panel.t2.list_male) * 100).toFixed(
                    2
                  )
                }}% ({{ panel.t2.reserve_male }}人)
              </td>
              <td>
                {{
                  (
                    (panel.t2.checkin_male / panel.t2.reserve_male) *
                    100
                  ).toFixed(2)
                }}% ({{ panel.t2.checkin_male }}人)
              </td>
            </tr>
            <tr>
              <td>女性</td>
              <td>{{ panel.t2.list_female }}人</td>
              <td>
                {{
                  (
                    (panel.t2.reserve_female / panel.t2.list_female) *
                    100
                  ).toFixed(2)
                }}% ({{ panel.t2.reserve_female }}人)
              </td>
              <td>
                {{
                  (
                    (panel.t2.checkin_female / panel.t2.reserve_female) *
                    100
                  ).toFixed(2)
                }}% ({{ panel.t2.checkin_female }}人)
              </td>
            </tr>
            <tr>
              <td rowspan="2">65 歲以上</td>
              <td>男性</td>
              <td>{{ panel.t3.list_male }}人</td>
              <td>
                {{
                  ((panel.t3.reserve_male / panel.t3.list_male) * 100).toFixed(
                    2
                  )
                }}% ({{ panel.t3.reserve_male }}人)
              </td>
              <td>
                {{
                  (
                    (panel.t3.checkin_male / panel.t3.reserve_male) *
                    100
                  ).toFixed(2)
                }}% ({{ panel.t3.checkin_male }}人)
              </td>
            </tr>
            <tr>
              <td>女性</td>
              <td>{{ panel.t3.list_female }}人</td>
              <td>
                {{
                  (
                    (panel.t3.reserve_female / panel.t3.list_female) *
                    100
                  ).toFixed(2)
                }}% ({{ panel.t3.reserve_female }}人)
              </td>
              <td>
                {{
                  (
                    (panel.t3.checkin_female / panel.t3.reserve_female) *
                    100
                  ).toFixed(2)
                }}% ({{ panel.t3.checkin_female }}人)
              </td>
            </tr>
            <tr>
              <td rowspan="2">總和</td>
              <td>-</td>
              <td>
                {{
                  panel.t1.list_male +
                  panel.t2.list_male +
                  panel.t3.list_male +
                  panel.t1.list_female +
                  panel.t2.list_female +
                  panel.t3.list_female
                }}人
              </td>
              <td>
                {{
                  (
                    ((panel.t1.reserve_male +
                      panel.t2.reserve_male +
                      panel.t3.reserve_male +
                      panel.t1.reserve_female +
                      panel.t2.reserve_female +
                      panel.t3.reserve_female) /
                      (panel.t1.list_male +
                        panel.t2.list_male +
                        panel.t3.list_male +
                        panel.t1.list_female +
                        panel.t2.list_female +
                        panel.t3.list_female)) *
                    100
                  ).toFixed(2)
                }}% ({{
                  panel.t1.reserve_male +
                  panel.t2.reserve_male +
                  panel.t3.reserve_male +
                  panel.t1.reserve_female +
                  panel.t2.reserve_female +
                  panel.t3.reserve_female
                }}人)
              </td>
              <td>
                {{
                  (
                    ((panel.t1.checkin_male +
                      panel.t2.checkin_male +
                      panel.t3.checkin_male +
                      panel.t1.checkin_female +
                      panel.t2.checkin_female +
                      panel.t3.checkin_female) /
                      (panel.t1.reserve_male +
                        panel.t2.reserve_male +
                        panel.t3.reserve_male +
                        panel.t1.reserve_female +
                        panel.t2.reserve_female +
                        panel.t3.reserve_female)) *
                    100
                  ).toFixed(2)
                }}% ({{
                  panel.t1.checkin_male +
                  panel.t2.checkin_male +
                  panel.t3.checkin_male +
                  panel.t1.checkin_female +
                  panel.t2.checkin_female +
                  panel.t3.checkin_female
                }}人)
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </v-container>
</template>

<script>
const 年度 = dayjs().get("year") - 1911;
import dayjs from "dayjs";
import _ from "lodash";
export default {
  name: "Main",
  data: () => ({
    originSections: [],
    panel: null,
    headers: [
      { text: "行政區", value: "行政區" },
      { text: "地點", value: "地點" },
      { text: "日期", value: "日期" },
      // { text: "整合式篩檢", value: "整合式篩檢" },
      { text: "人數上限", value: "人數上限" },
      { text: "已預約", value: "已預約" },
    ],
  }),
  computed: {
    lastUpdate() {
      return dayjs(this.panel.updateAt).format("YYYY-MM-DD HH:mm:ss");
    },
    sections() {
      let sections = [];
      this.originSections.forEach((section) => {
        let finded = _.find(sections, {
          日期: section.日期,
          地點: section.地點,
        });
        if (finded) {
          finded.人數上限 += parseInt(section.人數上限);
          finded.已預約 += parseInt(section.已預約);
        } else {
          sections.push({
            行政區: section.行政區,
            日期: section.日期,
            地點: section.地點,
            人數上限: parseInt(section.人數上限),
            已預約: parseInt(section.已預約),
          });
        }
      });
      sections = _.sortBy(sections, ["日期"]);
      return {
        past: _.filter(sections, (section) =>
          dayjs().isAfter(section.日期, "day")
        ),
        next: _.filter(
          sections,
          (section) =>
            dayjs().add(14, "day").isAfter(section.日期, "day") &&
            !dayjs().isAfter(section.日期, "day")
        ),
      };
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      let params = {
        年度,
      };
      this.originSections = (
        await this.axios.get("/dashboard/section", {
          params,
        })
      ).data;
      this.panel = (await this.axios.get("/dashboard/panel")).data;
    },
  },
};
</script>

<style lang="scss" scoped></style>
